import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Column } from 'foundations-components/transitional/components/Column';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FileInput } from 'foundations-components/transitional/components/FileInput';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { uploadAvatar } from '../api/AvatarAPI';
import { DEFAULT_MAX_UPLOAD_SIZE_MB } from '../Constants';
import megabytesToBytes from '../lib/megabytesToBytes';
import { UploaderAvatar } from './UploaderAvatar';
import { UploaderModalAlert } from './UploaderModalAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const fileReader = new FileReader();
const ACCEPT_FILE_TYPES = ['image/*'];
class UploaderModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      imageBuffer: undefined,
      alert: undefined
    };
    this.onChange = e => {
      this.onDismissAlert();
      fileReader.onload = event => {
        var _event$target;
        this.setState({
          imageBuffer: (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result
        });
      };
      if (typeof e.target.value !== 'undefined') {
        const file = e.target.value;
        if (file.size > megabytesToBytes(DEFAULT_MAX_UPLOAD_SIZE_MB)) {
          const imageTooBig = {
            titleText: I18n.text('uiAddonAvatars.defaultUploader.alerts.imageTooBig.title'),
            text: I18n.text('uiAddonAvatars.defaultUploader.alerts.imageTooBig.text')
          };
          this.setState({
            alert: imageTooBig
          });
        } else {
          fileReader.readAsArrayBuffer(file);
        }
      }
    };
    this.onUploadClick = () => {
      const {
        onConfirm,
        portalId,
        lookup: {
          type,
          primaryIdentifier
        }
      } = this.props;
      const {
        imageBuffer
      } = this.state;
      const formData = new FormData();
      const imageBlob = new Blob([new Uint8Array(imageBuffer)]);
      formData.append('imageData', imageBlob);
      uploadAvatar(portalId, type, primaryIdentifier, formData).then(({
        uri
      }) => {
        onConfirm(uri);
      }).catch(() => {
        this.setState({
          alert: {
            type: 'danger',
            titleText: I18n.text('uiAddonAvatars.defaultUploader.alerts.apiError.title'),
            text: I18n.text('uiAddonAvatars.defaultUploader.alerts.apiError.text')
          }
        });
      });
    };
    this.onDismissAlert = () => {
      this.setState({
        alert: undefined
      });
    };
    this.onCancelClick = () => {
      this.props.onReject();
    };
  }
  render() {
    const {
      alert
    } = this.state;
    return /*#__PURE__*/_jsxs(Modal, {
      size: "auto",
      width: 400,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: this.onCancelClick
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "uiAddonAvatars.defaultUploader.title"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(UploaderModalAlert, {
          text: alert === null || alert === void 0 ? void 0 : alert.text,
          titleText: alert === null || alert === void 0 ? void 0 : alert.titleText,
          type: alert === null || alert === void 0 ? void 0 : alert.type,
          onClose: this.onDismissAlert
        }), /*#__PURE__*/_jsxs(ColumnWrapper, {
          align: "center",
          children: [/*#__PURE__*/_jsx(ColumnSpreads, {
            align: "center",
            children: /*#__PURE__*/_jsx(UploaderAvatar, {
              imageBuffer: this.state.imageBuffer,
              lookup: this.props.lookup
            })
          }), /*#__PURE__*/_jsx(Column, {
            children: /*#__PURE__*/_jsx(FileInput
            // @ts-expect-error cannot find declaration for accept
            , {
              accept: ACCEPT_FILE_TYPES,
              onChange: this.onChange,
              showFilePreview: false,
              type: "button",
              use: "tertiary",
              "data-test-id": "uiFileInput-input"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: !this.state.imageBuffer,
          onClick: this.onUploadClick,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "uiAddonAvatars.defaultUploader.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: this.onCancelClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "uiAddonAvatars.defaultUploader.cancel"
          })
        })]
      })]
    });
  }
}
export default UploaderModal;